export { default } from './StoryAndSourceChecker';
export { default as reducer } from './StoryAndSourceChecker.ducks';
export { default as sagas } from './StoryAndSourceChecker.sagas';

import * as actions from './StoryAndSourceChecker.ducks';
export { actions };
